module.exports = __webpack_public_path__ + "static/media/illustartion-surfer.56d49e90.svg";